module.exports = __webpack_public_path__ + "img/ico_3.3cc6ee20.svg";